import HTTPClient from '../common/http-client'
import AppConstants from '../constants/app.constants'

export const settingWizardService = {
  getSettingWizardData,
  updateStepInfo
}

function getHttpSettingWizard() {
  return HTTPClient.getInstance().http
}

/**
 * 設定ウィザード データを取得します。
 * @param {number} hubId - ハブ ID
 */
async function getSettingWizardData(hubId) {
  const res = await getHttpSettingWizard().get('setup?hubId=' + hubId)
  return res.data
}

/**
 * ステップ情報を更新します。
 * @param {number} hubId - ハブ ID
 * @param {string} completedSteps - 完了したステップ
 * @param {number} finishedSetup - フラグ設定完了
 */
async function updateStepInfo(hubId, completedSteps, finishedSetup = AppConstants.MST_SETUP_NOT_FINISHED_SETUP) {
  const dataParam = { hubId, completedSteps }
  if (finishedSetup) {
    dataParam.finishedSetup = finishedSetup
  }
  const res = await getHttpSettingWizard().put('setup', dataParam)
  return res.data
}



// WEBPACK FOOTER //
// ./src/_services/setting-wizard.service.js